import { Injectable } from '@angular/core';
import { SurveyService } from '../survey/survey.service';

@Injectable({
  providedIn: 'root'
})
export class OfficesUtilsService {
  constructor(private surveyService: SurveyService) {
  }

  setOfficeNameInSurvey(hasCorpLicense: any) {
    const surveyModel = this.surveyService.surveyModel;

    if (hasCorpLicense == 'Yes') {
      surveyModel.setValue('business_name', '');
      surveyModel.getQuestionByName('business_name').readOnly = false;
    } else {
      let officeName;
      if ((surveyModel.getValue('FirstName').length + surveyModel.getValue('LastName').length) < 22) {
        officeName = `${surveyModel.getValue('FirstName').trim()} ${surveyModel.getValue('LastName')}, ${surveyModel.getValue('LicType')}`;
      } else {
        officeName = `${surveyModel.getValue('FirstName').substring(0, 1)} ${surveyModel.getValue('LastName')}, ${surveyModel.getValue('LicType')}`;
      }
      surveyModel.setValue('business_name', officeName);
      surveyModel.setVariable('office_name', officeName);
      surveyModel.getQuestionByName('business_name').readOnly = true;
    }
  }
}
